import { isAuthAdmin, isInstAdmin, isLicenseAdmin } from "../utils";
import useAdminUser from "./useAdminUser";

const useCanAdminInstitution = (institution) => {
  const adminUser = useAdminUser();
  if (!adminUser) return false;
  if (isAuthAdmin(adminUser) || isLicenseAdmin(adminUser)) return true;
  if (isInstAdmin(adminUser) && institution.administrators && institution.administrators.find(a => a._id === adminUser._id)) return true;
  return false;
};

export default useCanAdminInstitution;



// WEBPACK FOOTER //
// ./webAdmin/hooks/useCanAdminInstitution.js